import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { modififyDropdownServiceNameList } from "../../../../../services/fetchDropdownListData";
import secureStorage from "../../../../../services/secureStorage";
import { Add } from "../../../../../utility/constants/assetsManager";
import { colorLightGrey } from "../../../../../utility/constants/colorManager";
import {
  SS_ADMIN_ID,
  SS_AUTH_TOKEN,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  FLAT,
  RESELLER,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomSelect from "../../../../components/main_comps/custom_select";
import CheckBoxInput, {
  SerivceProviderDropdown,
} from "../../../../components/ui_comps/CheckBoxInput";
import ComissionContainer, {
  checkObjHasAllValue,
} from "../../../../components/ui_comps/ComissionContainer";
import RowButton from "../../../../components/ui_comps/RowButton";
import { formDataPush } from "./ResellerDetails";

const Input = ({ title, value, onChange, placeholder, validator }) => {
  return (
    <div>
      <p
        style={{
          ...textStyle,
          fontWeight: "500",
          color: "black",
        }}
      >
        {title}
      </p>
      <CustomInput
        className="input-placeholder"
        value={value}
        onChange={(data) => {
          onChange(data);
        }}
        inputcomponentStyles={{
          ...inputStyle,
          backgroundColor: "white",
          borderRadius: 4,
        }}
        placeholder={placeholder}
        validator={validator}
        type="input"
        inputStyles={{
          ...containerStyle,
        }}
      />
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 50,
  width: "100%",
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  borderRadius: 5,
  boxSizing: "border-box",
};
const containerStyle = {
  padding: 0,
  height: 50,
  marginBottom: 10,
};

const textStyle = {
  fontSize: 12,
  color: "#6C6B6B",
  margin: "5px 0px",
};

function ResellerDetails1({ onClickBack, onSuccess, onClickNext }) {
  const { enqueueSnackbar } = useSnackbar();
  const clientData = useSelector((state) => state.onboardClientSlice);
  const [serviceType, setServiceType] = useState([]);
  const [service, setService] = useState([]);
  const [serviceDetails1, setServiceDetails1] = useState({});
  const [serviceDetails2, setServiceDetails2] = useState({});
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [createdBy, setCreatedBy] = useState({});
  const [serviceDropdownValue2, setServiceDropdownValue2] = useState({});
  const [serviceDropdownValue1, setServiceDropdownValue1] = useState({});
  const [resellerName, setResellerName] = useState("");
  const [adminId, setAdminId] = useState("");
  const [loading, setLoading] = useState(false);
  const [payinServiceList, setPayinServiceList] = useState([
    {
      label: "None",
      value: "",
    },
  ]);
  const [payoutServiceList, setPayoutServiceList] = useState([
    {
      label: "None",
      value: "",
    },
  ]);
  const dispatch = useDispatch();

  //
  const [resellerDetails, setResellerDetails] = useState("");
  const [resellerData, setResellerData] = useState([]);

  //

  const [commissionRate, setCommissionRate] = useState([]);
  const [flatData, setFlatData] = useState([]);
  const [type, setType] = useState([]);
  const [commissionRate1, setCommissionRate1] = useState([]);
  const [flatData1, setFlatData1] = useState([]);
  const [type1, setType1] = useState([]);

  const alterArrays = (val) => {
    if (serviceType.includes(val)) {
      let filteredData = serviceType.filter((vals, i) => vals !== val);
      setServiceType(filteredData);
      if (filteredData[0] === "payin") {
        setService([
          {
            serviceType: filteredData[0],
            ...serviceDetails1,
          },
        ]);
        setServiceDetails2({});
        setServiceDropdownValue1({});
      } else {
        setService([
          {
            serviceType: filteredData[0],
            ...serviceDetails2,
          },
        ]);
        setServiceDetails1({});
        setServiceDropdownValue2({});
      }
    } else {
      setServiceType([...serviceType, val]);
      if (val === "payin") {
        setService([
          ...service,
          {
            serviceType: val,
            ...serviceDetails1,
          },
        ]);
      } else {
        setService([
          ...service,
          {
            serviceType: val,
            ...serviceDetails2,
          },
        ]);
      }
    }
  };

  const getData = async () => {
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const role = await secureStorage.getItem(SS_ROLE);
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const email = await secureStorage.getItem(SS_EMAIL);
    const adminid = await secureStorage.getItem(SS_ADMIN_ID);
    setCreatedBy({ email, userName: firstName + " " + lastName });

    if (role?.toLocaleUpperCase() === RESELLER) {
      setResellerName(firstName + " " + lastName);
      setAdminId(adminid);
    }
    setUserId(id);
    setRole(role);
  };

  const modififyDropdownData = (data) => {
    let arr = [
      {
        label: "Select Reseller",
        value: "",
        commissionRate: "",
        commissionType: "",
        userRefId: "",
      },
    ];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.userId,
          label: val.firstName + " " + val.lastName,
          commissionRate: val?.comissionRate,
          commissionType: val?.comissionType,
          userRefId: val?.userRefId,
        });
      });

    return arr;
  };

  const getResellerList = () => {
    ApiRequestGet.getResellerList()
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setResellerData(modififyDropdownData(res.data));
        }
      })
      .catch((err) => {});
  };

  const fetchPayinDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payin",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };

  const fetchPayoutDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payout",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };

  const updateValues = (type) => {
    const datas = service.map((obj, i) => {
      if (obj["serviceType"] === "payin") {
        return { ...obj, ...serviceDetails1 };
      } else if (obj["serviceType"] === "payout") {
        return { ...obj, ...serviceDetails2 };
      }
      return obj;
    });

    setService([...datas]);
  };

  const onClickAddClient = (data) => {
    setLoading(true);

    const formdata = formDataPush({ ...clientData, ...data });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "client/create", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
        isimageurl: true,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (serviceType.length === 0) {
      setService([]);
      setServiceDetails1({});
      setServiceDetails2({});
      setServiceDropdownValue1({});
      setServiceDropdownValue2({});
    }
  }, [serviceType]);

  useEffect(() => {
    if (
      serviceDetails1["serviceProviderName"] &&
      serviceDetails1["serviceProviderRate"]
    ) {
      updateValues("payin");
    }
  }, [serviceDetails1]);

  useEffect(() => {
    if (
      serviceDetails2["serviceProviderName"] &&
      serviceDetails2["serviceProviderRate"]
    ) {
      updateValues("payout");
    }
  }, [serviceDetails2]);

  useEffect(() => {
    if (type && (commissionRate || flatData)) {
      let obj = [];

      if (
        type === FLAT
          ? checkObjHasAllValue({
              ...flatData,
            })
          : checkObjHasAllValue({
              ...commissionRate,
            })
      ) {
        if (type === FLAT) {
          obj.push(flatData);
        } else {
          obj.push(...commissionRate);
        }
      }
      setServiceDetails1({
        ...serviceDetails1,
        comissionRate: obj,
        comissionType: type,
      });
    }
  }, [commissionRate, type, flatData]);

  useEffect(() => {
    if (type1 && (commissionRate1 || flatData1)) {
      let obj1 = [];

      if (
        type1 === FLAT
          ? checkObjHasAllValue({
              ...flatData1,
            })
          : checkObjHasAllValue({
              ...commissionRate1,
            })
      ) {
        if (type1 === FLAT) {
          obj1.push(flatData1);
        } else {
          obj1.push(...commissionRate1);
        }
      }
      setServiceDetails2({
        ...serviceDetails2,
        comissionRate: obj1,
        comissionType: type1,
      });
    }
  }, [commissionRate1, type1, flatData1]);

  useEffect(() => {
    getData();
    fetchPayinDropDown();
    fetchPayoutDropDown();
    getResellerList();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          overflow: "auto",
          maxHeight: 600,
        }}
        className="hide-scroll-bar"
      >
        {role?.toUpperCase() !== CLIENT && role?.toUpperCase() !== RESELLER ? (
          <div>
            <p style={textStyle}>Select Reseller Name</p>
            <CustomSelect
              value={resellerDetails}
              onChange={(data) => {
                setResellerDetails(data);
              }}
              options={resellerData}
            />
          </div>
        ) : (
          <div>
            <p style={textStyle}>Reseller Name</p>
            <CustomInput
              value={resellerName}
              // onChange={(data) => setResellerName(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Reseller name"
              validator="name"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              disabled={true}
            />
          </div>
        )}

        <div>
          <p style={textStyle}>Service Type</p>
          <CheckBoxInput
            title="Pay In"
            value={"payin"}
            onChange={(val) => {
              if (!clientData?.bankAccountNumber && !clientData?.bankIfscCode) {
                enqueueSnackbar("Please add settlement account to add payin");
              } else {
                alterArrays(val.target.value);
              }
            }}
          />

          {serviceType.includes("payin") && (
            <>
              <div
                style={{
                  width: "100%",
                  backgroundColor: colorLightGrey,
                  padding: "10px 15px",
                  marginBottom: 5,
                }}
              >
                <SerivceProviderDropdown
                  onChange1={(val) => {
                    if (val.label?.toLowerCase() !== "kopay") {
                      setServiceDetails1({
                        ...serviceDetails1,
                        merchantId: "",
                        cidNumber: "",
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                        clientUpiId: "",
                        mechanism: [],
                        comissionRate: "",
                        comissionType: "",
                      });
                    } else {
                      setServiceDetails1({
                        ...serviceDetails1,
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                        comissionRate: "",
                        comissionType: "",
                      });
                    }
                    setServiceDropdownValue1(val);
                  }}
                  serviceProviderNameList={payinServiceList}
                  rateValue={serviceDetails1.serviceProviderRate}
                  value1={serviceDropdownValue1}
                />
                <Input
                  title="Neokred Rate"
                  value={serviceDetails1.neokredRate}
                  onChange={(data) => {
                    setServiceDetails1({
                      ...serviceDetails1,
                      neokredRate: data,
                    });
                  }}
                  placeholder="Neokred Rate"
                  validator="decimal"
                />
                <Input
                  title="Reseller Rate"
                  value={serviceDetails1.resellerRate}
                  onChange={(data) => {
                    setServiceDetails1({
                      ...serviceDetails1,
                      resellerRate: data,
                    });
                  }}
                  placeholder="Reseller Rate"
                  validator="decimal"
                />

                <div>
                  <p style={textStyle}>Client comission</p>
                  <ComissionContainer
                    onClickNext={(data, flatData, type) => {
                      setCommissionRate(data);
                      setFlatData(flatData);
                      setType(type?.toUpperCase());
                    }}
                    isSlabRequired={true}
                    styles={{
                      backgroundColor: "white",
                      padding: 5,
                    }}
                  />
                </div>

                {serviceDetails1.serviceProviderName?.toLowerCase() ===
                  "kopay" && (
                  <>
                    <Input
                      title="CID Number"
                      value={serviceDetails1.cidNumber}
                      onChange={(data) => {
                        setServiceDetails1({
                          ...serviceDetails1,
                          cidNumber: data,
                        });
                      }}
                      placeholder="CID Number"
                      validator=""
                    />
                    <Input
                      title="Client UPI Id"
                      value={serviceDetails1.clientUpiId}
                      onChange={(data) => {
                        setServiceDetails1({
                          ...serviceDetails1,
                          clientUpiId: data,
                        });
                      }}
                      placeholder="Client UPI Id"
                      validator=""
                    />
                    <Input
                      title="Merchant ID"
                      value={serviceDetails1.merchantId}
                      onChange={(data) => {
                        setServiceDetails1({
                          ...serviceDetails1,
                          merchantId: data,
                        });
                      }}
                      placeholder="Merchant ID"
                      validator=""
                    />
                    <p style={{ ...textStyle, color: "black" }}>Mechanism</p>

                    <div
                      style={{
                        backgroundColor: "white",
                        marginBottom: 5,
                        display: "flex",
                        borderRadius: "1px solid white",
                      }}
                    >
                      <CheckBoxInput
                        title="VBA"
                        value={"vba"}
                        onChange={(val) => {
                          if (serviceDetails1?.mechanism?.includes("vba")) {
                            let arr = serviceDetails1?.mechanism?.filter(
                              (o) => o !== "vba"
                            );
                            setServiceDetails1({
                              ...serviceDetails1,
                              mechanism: arr,
                            });
                            serviceDetails1?.mechanism?.push(arr);
                          } else {
                            let temp = serviceDetails1?.mechanism ?? [];
                            temp.push("vba");
                            setServiceDetails1({
                              ...serviceDetails1,
                              mechanism: temp,
                            });
                          }
                        }}
                        inputStyle={{ backgroundColor: "red", width: "60px" }}
                      />
                      <CheckBoxInput
                        title="QR"
                        value={"qr"}
                        onChange={(val) => {
                          if (serviceDetails1?.mechanism?.includes("qr")) {
                            let arr = serviceDetails1?.mechanism?.filter(
                              (o) => o !== "qr"
                            );
                            setServiceDetails1({
                              ...serviceDetails1,
                              mechanism: arr,
                            });
                            serviceDetails1?.mechanism?.push(arr);
                          } else {
                            let temp = serviceDetails1?.mechanism ?? [];
                            temp.push("qr");
                            setServiceDetails1({
                              ...serviceDetails1,
                              mechanism: temp,
                            });
                          }
                        }}
                        inputStyle={{ backgroundColor: "white" }}
                      />
                    </div>
                  </>
                )}
                <Input
                  title="Notify Url"
                  value={serviceDetails1.notifyUrl}
                  onChange={(data) => {
                    setServiceDetails1({
                      ...serviceDetails1,
                      notifyUrl: data,
                    });
                  }}
                  placeholder="Notify Url"
                  validator=""
                />
                <Input
                  title="Validate Url"
                  value={serviceDetails1.validateUrl}
                  onChange={(data) => {
                    setServiceDetails1({
                      ...serviceDetails1,
                      validateUrl: data,
                    });
                  }}
                  placeholder="Validate Url"
                  validator=""
                />
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginTop: "5px" }}>
                  <img style={{ height: "20px", width: "20px" }} src={Add} />
                </div>
                <div
                  style={{
                    color: "#FF9800",
                    fontSize: "14",
                    fontWeight: "400",
                    marginTop: "5px",
                    paddingLeft: "10px",
                  }}
                >
                  Add Service Provider
                </div>
              </div>
            </>
          )}
        </div>

        <div>
          <p style={textStyle}>Service Type</p>
          <CheckBoxInput
            title="Pay Out"
            value={"payout"}
            onChange={(val) => {
              if (
                !clientData?.remitterAccountNumber &&
                !clientData?.remitterIfscCode
              ) {
                enqueueSnackbar("Please add remitter account to add payout", {
                  variant: "error",
                });
              } else {
                alterArrays(val.target.value);
              }
            }}
          />

          {serviceType.includes("payout") && (
            <>
              <div
                style={{
                  width: "100%",
                  backgroundColor: colorLightGrey,
                  padding: "10px 15px",
                  marginBottom: 5,
                }}
              >
                <SerivceProviderDropdown
                  onChange1={(val) => {
                    if (val.label?.toLowerCase() !== "kopay") {
                      setServiceDetails2({
                        ...serviceDetails2,
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                        comissionRate: "",
                        comissionType: "",
                      });
                    } else {
                      setServiceDetails2({
                        ...serviceDetails2,
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                        comissionRate: "",
                        comissionType: "",
                      });
                    }
                    setServiceDropdownValue2(val);
                  }}
                  serviceProviderNameList={payoutServiceList}
                  rateValue={serviceDetails2.serviceProviderRate}
                  value1={serviceDropdownValue2}
                />
                <Input
                  title="Neokred Rate"
                  value={serviceDetails2.neokredRate}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      neokredRate: data,
                    });
                  }}
                  placeholder="Neokred Rate"
                  validator="decimal"
                />
                <Input
                  title="Reseller Rate"
                  value={serviceDetails2.resellerRate}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      resellerRate: data,
                    });
                  }}
                  placeholder="Reseller Rate"
                  validator="decimal"
                />
                <div>
                  <p style={textStyle}>Client comission</p>
                  <ComissionContainer
                    onClickNext={(data, flatData, type) => {
                      setCommissionRate1(data);
                      setFlatData1(flatData);
                      setType1(type?.toUpperCase());
                    }}
                    isSlabRequired={true}
                    styles={{
                      backgroundColor: "white",
                      padding: 5,
                    }}
                  />
                </div>

                {serviceDetails2.serviceProviderName?.toLowerCase() ===
                  "kopay" && (
                  <>
                    <Input
                      title="CID Number"
                      value={serviceDetails2.cidNumber}
                      onChange={(data) => {
                        setServiceDetails2({
                          ...serviceDetails2,
                          cidNumber: data,
                        });
                      }}
                      placeholder="CID Number"
                      validator=""
                    />
                    <Input
                      title="Client UPI Id"
                      value={serviceDetails2.clientUpiId}
                      onChange={(data) => {
                        setServiceDetails2({
                          ...serviceDetails2,
                          clientUpiId: data,
                        });
                      }}
                      placeholder="Client UPI Id"
                      validator=""
                    />
                    <Input
                      title="Merchant ID"
                      value={serviceDetails2.merchantId}
                      onChange={(data) => {
                        setServiceDetails2({
                          ...serviceDetails2,
                          merchantId: data,
                        });
                      }}
                      placeholder="Merchant ID"
                      validator=""
                    />
                  </>
                )}
                <Input
                  title="Notify Url"
                  value={serviceDetails2.notifyUrl}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      notifyUrl: data,
                    });
                  }}
                  placeholder="Notify Url"
                  validator=""
                />
                <Input
                  title="Validate Url"
                  value={serviceDetails2.validateUrl}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      validateUrl: data,
                    });
                  }}
                  placeholder="Validate Url"
                  validator=""
                />
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginTop: "5px" }}>
                  <img style={{ height: "20px", width: "20px" }} src={Add} />
                </div>
                <div
                  style={{
                    color: "#FF9800",
                    fontSize: "14",
                    fontWeight: "400",
                    marginTop: "5px",
                    paddingLeft: "10px",
                  }}
                >
                  Add Service Provider
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          let checkObj1 = {};
          let checkObj2 = {};
          let obj = [];
          if (
            type === FLAT
              ? checkObjHasAllValue({
                  ...flatData,
                })
              : checkObjHasAllValue({
                  ...commissionRate,
                })
          ) {
            if (type === FLAT) {
              obj.push(flatData);
            } else {
              obj.push(...commissionRate);
            }
          }

          let obj1 = [];

          if (
            type === FLAT
              ? checkObjHasAllValue({
                  ...flatData1,
                })
              : checkObjHasAllValue({
                  ...commissionRate1,
                })
          ) {
            if (type === FLAT) {
              obj1.push(flatData1);
            } else {
              obj1.push(...commissionRate1);
            }
          }

          if (serviceDetails1.serviceProviderName?.toLowerCase() === "kopay") {
            checkObj1 = {
              notifyUrl: serviceDetails1.notifyUrl,
              serviceProviderName: serviceDetails1.serviceProviderName,
              serviceProviderRate: serviceDetails1.serviceProviderRate,
              serviceType: "payin",
              cidNumber: serviceDetails1.cidNumber,
              merchantId: serviceDetails1.merchantId,
              clientUpiId: serviceDetails1.clientUpiId,
              mechanism: serviceDetails1.mechanism,
              resellerRate: serviceDetails1.resellerRate,
              neokredRate: serviceDetails1.neokredRate,
              comissionRate: JSON.stringify([...obj]),
              comissionType: type,
            };
          } else {
            checkObj1 = {
              notifyUrl: serviceDetails1.notifyUrl,
              serviceProviderName: serviceDetails1.serviceProviderName,
              serviceProviderRate: serviceDetails1.serviceProviderRate,
              serviceType: "payin",
              resellerRate: serviceDetails1.resellerRate,
              neokredRate: serviceDetails1.neokredRate,
              comissionRate: JSON.stringify([...obj]),
              comissionType: type,
            };
          }

          checkObj2 = {
            notifyUrl: serviceDetails2.notifyUrl,
            validateUrl: serviceDetails2?.validateUrl ?? "",
            serviceProviderName: serviceDetails2.serviceProviderName,
            serviceProviderRate: serviceDetails2.serviceProviderRate,
            serviceType: "payout",

            resellerRate: serviceDetails2.resellerRate,
            neokredRate: serviceDetails2.neokredRate,
            comissionRate: JSON.stringify([...obj1]),
            comissionType: type1,
          };

          if (
            serviceType.length !== 0 &&
            (serviceType.length === 1
              ? checkObjHasAllValue({ ...checkObj1 }) ||
                checkObjHasAllValue({ ...checkObj2 })
              : checkObjHasAllValue({ ...checkObj1 }) &&
                checkObjHasAllValue({ ...checkObj2 }))
          ) {
            // onClickAddClient({
            //   userRefId:
            //     role?.toUpperCase() !== CLIENT &&
            //     role?.toUpperCase() !== RESELLER
            //       ? resellerDetails?.value
            //       : userId,
            //   resellerName:
            //     role?.toUpperCase() !== CLIENT &&
            //     role?.toUpperCase() !== RESELLER
            //       ? resellerDetails?.label
            //       : resellerName,
            //   rootReferenceId:
            //     role?.toUpperCase() !== CLIENT &&
            //     role?.toUpperCase() !== RESELLER
            //       ? resellerDetails?.userRefId
            //       : adminId,
            //   service: JSON.stringify(service),
            //   createdBy: JSON.stringify(createdBy),

            //   // rootReferenceId
            // });
            onClickNext({
              userRefId:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.value
                  : userId,
              resellerName:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.label
                  : resellerName,
              rootReferenceId:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.userRefId
                  : adminId,
              service: JSON.stringify(service),
              createdBy: JSON.stringify(createdBy),
            });
          } else {
            enqueueSnackbar("Please fill all the fields", {
              variant: "error",
            });
          }
        }}
        loading={loading}
      />
    </div>
  );
}

export default ResellerDetails1;
